const CollectionPageSchema = ({
  name,
  description,
  url
}) => ({
  "@type": "CollectionPage",
  "@id": `${url}#webpage`,

  "url": url,

  "name": name,

  "description": description,

  "isPartOf": {
    "@id": "https://onbbits.io/#website"
  },

  "about": {
    "@id": "https://onbbits.io/#organization"
  }
});

export default CollectionPageSchema;